import { useEffect } from "react";
import { Box, Button } from "@material-ui/core";
import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import {
  ApplicationMainModelFileTypeEnum,
  ContentTypeEnum,
} from "../../../../../generated/graphql";
import {
  ALLOWED_PLATFORMS_BY_TYPE,
  PLATFORM_LABELS,
  PLATFORM_TO_BUNDLE_URL_FIELD,
} from "../../constants";

const platformKeys = Object.keys(PLATFORM_LABELS);

export const PlatformTabs = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const contentType = model?.contentType?.name;

  const activePlatform = useReactiveVar(mobileAppModel.activePlatform);
  const isBundleListEmpty = !model?.modelBundle?.id && !model?.bundles?.length;

  const getIsDisabled = (platformKey: string) => {
    if (!contentType || isBundleListEmpty) return true;

    if (model?.modelBundle?.id) {
      const field =
        PLATFORM_TO_BUNDLE_URL_FIELD[
          platformKey as ApplicationMainModelFileTypeEnum
        ];
      return !model.modelBundle[field as keyof typeof model.modelBundle];
    }

    const allowedPlatforms = ALLOWED_PLATFORMS_BY_TYPE[contentType];

    return !allowedPlatforms?.includes(platformKey);
  };

  useEffect(() => {
    const firstEnabled = platformKeys.find((key) => !getIsDisabled(key));
    if (firstEnabled) {
      mobileAppModel.setActivePlatform(firstEnabled);
    }
  }, [contentType, isBundleListEmpty]);

  return (
    <Box display="flex" flexWrap="wrap" mt={2} gridGap={6} maxWidth={520}>
      {platformKeys.map((key) => {
        const disabled = getIsDisabled(key);

        return (
          <Button
            key={key}
            onClick={() => mobileAppModel.setActivePlatform(key)}
            disabled={disabled}
            variant="outlined"
            style={{
              textTransform: "none",
              border: "2px solid black",
              borderRadius: 12,
              backgroundColor: activePlatform === key ? "#ffe066" : "#ffffff",
              fontWeight: activePlatform === key ? "bold" : "normal",
              color: "black",
              marginRight: 8,
              marginBottom: 8,
              opacity: disabled ? 0.4 : 1,
            }}
          >
            {PLATFORM_LABELS[key]}
          </Button>
        );
      })}
    </Box>
  );
};
